import React from 'react';
import { Mail, Briefcase } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Careers() {
  const areas = [
    'Financial Markets & Investments',
    'Operations, Finance & Systems'
  ];

  return (
    <section id="careers" className="py-12 sm:py-16 md:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4 sm:mb-6">
            Careers
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-6 sm:mb-8 px-2">
            We welcome driven individuals who want to learn, build, and grow alongside India's financial markets in a merit-driven environment.
          </p>
        </div>

        {/* Focus Areas */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {areas.map((area, index) => (
            <div
              key={index}
              className="px-5 py-2.5 bg-accent/10 border border-accent/20 rounded-full text-sm font-medium text-foreground"
            >
              {area}
            </div>
          ))}
        </div>

        {/* Value Proposition */}
        <div className="bg-secondary/50 rounded-lg p-8 mb-8 border border-border">
          <div className="flex items-start gap-4">
            <Briefcase className="h-6 w-6 text-accent flex-shrink-0 mt-1" />
            <p className="text-base text-muted-foreground leading-relaxed">
              Gain exposure to real-world investment decision-making in a learning-focused, high-responsibility environment.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-muted-foreground mb-6">
            Email your resume with a brief introduction, contact person name, phone number, email, and comments:
          </p>
          <Button
            size="lg"
            className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold"
            onClick={() => window.location.href = 'mailto:mail@brionenterprises.in'}
          >
            <Mail className="mr-2 h-5 w-5" />
            hr@brionenterprises.in
          </Button>
        </div>
      </div>
    </section>
  );
}